module.exports = __webpack_public_path__ + "img/thumbs_up.3fb8b2b5.png";